import { SelectorTypesEnum } from "../types/enums";
import { formatNumber } from "./formatNumber";
import { declinationTermDays, declinationTermMonths } from "../types/constants";
import { getCorrectWord } from "./getCorrectWord";
export var getCaptionByType = function (value, unit, showUnit) {
    if (showUnit === void 0) { showUnit = true; }
    switch (unit) {
        case SelectorTypesEnum.SUM: {
            if (typeof value === "number") {
                return "".concat(formatNumber(value)).concat(showUnit ? ' руб.' : '');
            }
            return '';
        }
        case SelectorTypesEnum.TERM: {
            if (typeof value === "object" && value !== null && 'value' in value && 'vr' in value) {
                var termValue = value;
                var declination = termValue.vr === 2 ? declinationTermMonths : declinationTermDays;
                return "".concat(formatNumber(termValue.value)).concat(showUnit ? ' ' + getCorrectWord(termValue.value, declination) : '');
            }
            return '';
        }
        case SelectorTypesEnum.TEXT: {
            return value;
        }
        default:
            return '';
    }
};
export var getUnitCaption = function (value, unit) {
    switch (unit) {
        case SelectorTypesEnum.SUM: {
            if (typeof value === "number") {
                return ' руб.';
            }
            return '';
        }
        case SelectorTypesEnum.TERM: {
            if (typeof value === "object" && value !== null && 'value' in value && 'vr' in value) {
                var termValue = value;
                var declination = termValue.vr === 2 ? declinationTermMonths : declinationTermDays;
                return ' ' + getCorrectWord(termValue.value, declination);
            }
            return '';
        }
        default:
            return '';
    }
};
